<template>
  <van-row type="flex" justify="space-between" class="home-title">
    <div class="title">{{ title }}</div>
    <div class="tip" @click="more">{{ tip }}</div>
  </van-row>
</template>

<script>
export default {
  name: "titleItem",
  props: ['title', 'tip'],
  methods: {
    more() {
      this.$emit("more");
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../styles/style.less";
.home-title {
  color: @color-black;
  padding: 10px 16px;

  .title {
    font-size: 22px;
    margin: auto 0;
  }

  .tip {
    font-size: 12px;
    margin: auto 0;
  }
}
</style>